
import Vue from 'vue'
import { paginationEnums } from '~/enums/paginationEnums'

export default Vue.extend({
  name: 'RPHPaginationButton',
  props: {
    /* number of the page */
    pageNumber: {
      type: [String, Number],
      default: '',
    },
    /* make button disable */
    disabled: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Boolean,
      default: false,
    },
    /**
     * props to make button active
     */
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dots: paginationEnums.dots,
    }
  },
})
